import { render, staticRenderFns } from "./DvTextField.vue?vue&type=template&id=4037be02&scoped=true&lang=pug"
import script from "./DvTextField.vue?vue&type=script&lang=js"
export * from "./DvTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4037be02",
  null
  
)

export default component.exports